const table = state => state.table
const tables = state => state.tables
const progress = state => state.progress

export default {
  table,
  tables,
  progress
}
